import BaseForm from '../base';
export class EquipmentMapPanelForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
// Default GPS history behaviour for an Equipment Map panel. These write to the
// panel's config; the panel reads them on load (historyView, historyWindowMs).
export default {
    components: [
        {
            type: 'select',
            label: 'Default GPS history view',
            key: 'historyView',
            defaultValue: 'trips',
            description: 'How a GPS trail is drawn when the panel opens.',
            data: {
                values: [
                    { label: 'Trips & stops', value: 'trips' },
                    { label: 'All points', value: 'raw' },
                ],
            },
        },
        {
            type: 'select',
            label: 'Default history window',
            key: 'historyWindowMs',
            defaultValue: '',
            description: 'How far back GPS history is queried when the panel opens.',
            data: {
                values: [
                    { label: 'Last 25 fixes', value: '' },
                    { label: 'Last 24 hours', value: 86_400_000 },
                    { label: 'Last 3 days', value: 259_200_000 },
                    { label: 'Last 7 days', value: 604_800_000 },
                    { label: 'Last 30 days', value: 2_592_000_000 },
                ],
            },
        },
        {
            type: 'select',
            label: 'Default map style',
            key: 'mapType',
            defaultValue: 'roadmap',
            description: 'The base map shown when the panel opens.',
            data: {
                values: [
                    { label: 'Road', value: 'roadmap' },
                    { label: 'Satellite', value: 'satellite' },
                    { label: 'Hybrid', value: 'hybrid' },
                    { label: 'Terrain', value: 'terrain' },
                ],
            },
        },
    ],
};
